import { api } from '@/modules/shared/lib/axios'
import type { ResponseAPI } from '@/modules/shared/types/response-api.type'

export const customerFormJsonAddService = async (): Promise<ResponseAPI> => {
  const response = await api.get('novocliente')

  return response.data
}

export type TCustomerFormJsonEditOrView = {
  payload: {
    clientId: string
  }
}

export const customerFormJsonEditOrViewService = async ({
  payload,
}: TCustomerFormJsonEditOrView): Promise<ResponseAPI> => {
  const response = await api.get(`entidadecadastro/${payload.clientId}`)

  return response.data
}
